import { type Dispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

export const useAutomationDispatch = () => useDispatch<Dispatch<any>>();
